import { LockRemoveOutlineIcon } from './LockRemoveOutlineIcon';

/**
 * author: Colton Wiscombe
 * id D5069461-8385-4424-8E19-CE2BEF2C1BAC
 * name lock-remove-outline
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lock-remove-outline.svg
 * tags
 * - Lock 
 */
export const PasswordRemoveOutlineIcon = LockRemoveOutlineIcon;
export default PasswordRemoveOutlineIcon